import React from 'react';
import {useBreakpoint} from "../../../libs/breakpoint";
import connect from "react-redux/es/connect/connect";
import {bindActionCreators} from "redux";
import './_Adverising.scss';


const advertisingList = {
    //'300x100' : <iframe title="tool" width="300" height="100" src="https://tools.emstat.fr/voissa/300x100.php" frameBorder="0" marginWidth="0" marginHeight="0" scrolling="no" className={"h-100"}></iframe>
}

const AdvertisingShow = (props) => {
    let {sizeMobile = "0x0", sizeTable = "0x0", sizeDesktop = "0x0", className = ""} = props;
    const breakpoints = useBreakpoint();
    let source = localStorage.getItem(`${process.env.REACT_APP_TOKEN_NAME}_source`) || "";
    let size = "0x0";

    if (breakpoints.sm) {
        size = sizeMobile;
    } else if (breakpoints.md) {
        size = sizeTable;
    }
    else{
        size = sizeDesktop;
    }

    return ["", "voissa"].includes(source) && advertisingList[size] ? (
        <div className={`advertising ${className}`}>
            {advertisingList[size]}
        </div>
    ) : null;
}

const Advertising = (props) => {
    return !props.currentUserInitialized && !props.currentUserLoading ? (
        <AdvertisingShow {...props} />
    ) : null;
}

const mapStateToProps = (state) => {
    return {
        currentUserInitialized: state.currentUser.initialized,
        currentUserLoading: state.currentUser.loading,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({

}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Advertising);
